import { MyCutups } from '@statsbomb/video-client-js';
import React from 'react';

export function MyCutupsBasic() {
  return <MyCutups />;
}

export default { MyCutupsBasic };
